import { favoritesService } from '#/client/api';
import { resourceService } from '#/client/custom';
import {
  Collection,
  MediaResource,
  MediaType,
  mediaTypeToResourceType,
  ResourceItem,
  ResourceType,
} from '#/client/models';

const fetchMediaResource = async (
  itemId: string,
  mediaType: MediaType
): Promise<MediaResource> => {
  try {
    const resourceType = mediaTypeToResourceType[mediaType];
    const resource = await resourceService.get(resourceType, itemId);

    if (resourceType === ResourceType.Collection) {
      return (resource.data as Collection).collection;
    }

    if (resourceType === ResourceType.Item) {
      return (resource.data as ResourceItem).data;
    }

    throw new Error('Unknown resource type');
  } catch (err) {
    console.error('Favorites: error when fetching media resource', err);
    throw err;
  }
};

export const addToFavorites = async (
  itemId: string,
  mediaType: MediaType
): Promise<MediaResource> => {
  const mediaResource = await fetchMediaResource(itemId, mediaType);
  await favoritesService.add({ id: itemId, type: mediaResource.type });
  console.debug('Favorites: added to favorites', itemId);

  return mediaResource;
};

export const removeFromFavorites = async (
  itemId: string,
  mediaType: MediaType
): Promise<MediaResource> => {
  const mediaResource = await fetchMediaResource(itemId, mediaType);
  await favoritesService.remove({ id: itemId, type: mediaResource.type });
  console.debug('Favorites: removed from favorites', itemId);

  return mediaResource;
};
